import React from 'react';
import Input from '../Input/Input.js';
import standardInput from '../hocs/StandardInputHOC.js';
function StandardEmailInput(props) {
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    "data-cmp": "standardEmailInput",
    label: "Email",
    type: "email"
  }, props));
}
export default /* #__PURE__ */standardInput(StandardEmailInput, {
  validations: {
    isEmail: true
  },
  validationError: 'Enter a valid email address',
  validationErrors: {
    isDefaultRequiredValue: 'Enter your email address'
  }
});